import React from 'react';

const SectionHeading = ({ heading, subHeading, icon, additionalClasses, mainHeadingClass = 'c_dark', subHeadingClass = 'c-green', subHeadingIconSrc }) => {
    return (
        <div className={`section-heading ${additionalClasses}`}>
            {heading!="" && <div className={`sub-heading upper ls-1 ${subHeadingClass}`}>
                <i className={icon}></i>
                <h5>{heading}</h5>
            </div>}
            <div className={`main-heading d-flex align-items-center ${mainHeadingClass}`}>
                <h1 class="text-inter" style={{lineHeight:1}}>{subHeading}</h1>
                {subHeadingIconSrc&& <img class="ms-2" src={subHeadingIconSrc}></img>}
            </div>
        </div>
    );
};

export default SectionHeading;
